import * as yup from 'yup';
import { FIELD_REQUIRED_MSG } from '../../validation';

export const schema = yup.object().shape({
  allergy: yup.string().required(FIELD_REQUIRED_MSG),
});
